import { Stack, Group, Text, ActionIcon, Select, Box } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import { generateDurationOptions } from "../../../../../../utils/appointmentFormUtils";

function DurationSection({
  formData,
  onChange,
  onClose,
  services,
  errors,
  validateSection,
}) {
  const handleDurationChange = (field, value) => {
    onChange({ [field]: parseInt(value) || 0 });
  };

  const handleClose = () => {
    validateSection("duration");
    onClose();
  };

  const totalMinutes =
    (formData.baseDuration ?? 0) +
    (formData.processingTime ?? 0) +
    (formData.finishingTime ?? 0) +
    (formData.bufferTime ?? 0);

  return (
    <Stack p="md">
      {/* Header */}
      <Group w="100%" justify="space-between">
        <Text size="lg" fw={500}>
          Duration
        </Text>
        <ActionIcon
          onClick={handleClose}
          variant="subtle"
          color="var(--mantine-color-teal-1)"
        >
          <IconCheck size={20} color="var(--mantine-color-teal-6)" />
        </ActionIcon>
      </Group>

      {errors.duration && (
        <Text size="xs" c="red">
          {errors.duration}
        </Text>
      )}

      {/* Total Duration Display */}
      <Box>
        <Text size="sm" c="dimmed" mb="xs">
          Total Duration: {Math.floor(totalMinutes / 60)}hr {totalMinutes % 60}
          min
        </Text>
      </Box>

      {/* Duration Fields */}
      <Stack gap="md">
        <Select
          placeholder="Select minutes"
          label="Base Duration (minutes)"
          description="Active service time with client"
          data={generateDurationOptions()}
          value={formData.baseDuration.toString()}
          onChange={(value) => handleDurationChange("baseDuration", value)}
          styles={(theme) => ({
            input: {
              "&:focus": {
                borderColor: theme.colors.teal[5],
              },
            },
          })}
        />

        <Select
          placeholder="Select minutes"
          label="Processing Time (minutes)"
          description="Inactive time for treatments to process"
          data={[{ value: "0", label: "None" }, ...generateDurationOptions()]}
          value={formData.processingTime.toString()}
          onChange={(value) => handleDurationChange("processingTime", value)}
          styles={(theme) => ({
            input: {
              "&:focus": {
                borderColor: theme.colors.teal[5],
              },
            },
          })}
        />

        <Select
          placeholder="Select minutes"
          label="Finishing Time (minutes)"
          description="Active time to finalize the service"
          data={[{ value: "0", label: "None" }, ...generateDurationOptions()]}
          value={formData.finishingTime.toString()}
          onChange={(value) => handleDurationChange("finishingTime", value)}
          styles={(theme) => ({
            input: {
              "&:focus": {
                borderColor: theme.colors.teal[5],
              },
            },
          })}
        />

        <Select
          placeholder="Select minutes"
          label="Buffer Time (minutes)"
          description="Time blocked after appointment for cleanup/breaks"
          data={[{ value: "0", label: "None" }, ...generateDurationOptions()]}
          value={formData.bufferTime.toString()}
          onChange={(value) => handleDurationChange("bufferTime", value)}
          styles={(theme) => ({
            input: {
              "&:focus": {
                borderColor: theme.colors.teal[5],
              },
            },
          })}
        />
      </Stack>
    </Stack>
  );
}

export default DurationSection;
